import React, { forwardRef } from 'react';
import { keyCode } from '../helpers';

const _FormTab = ({activeTab, label, onClick, badge}, ref) => {


  const onClickTabItem = () => {
    onClick(label)
  }
  const handleKeyDown = (e) => {
    switch (e.keyCode) {
      case keyCode.ENTER:
      case keyCode.SPACE:
        onClickTabItem();
        break;

      default:
        break;
    }
  }

  const active = ((activeTab === label) ? "active" : "")

  return (
      <div 
        className={"tab-list-item " + active}
        role="tab"
        ref={ref}
        aria-selected={active === "active"}
        tabIndex= {0}
        onClick={onClickTabItem} 
        onKeyDown={handleKeyDown}
      >
        { label.toUpperCase() }
        { !!badge && <span className="tab-badge">{badge}</span> }
      </div>
  )
};
export const FormTab = forwardRef(_FormTab);
